import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { useGetClaim } from '@/api'
import { useCanPublishClaimInfoToXA } from '@eigtech/ui-shared-claims-lib'
import { Container } from '@eigtech/ui-shared-dave'
import { CreateEntityNotePage } from '@eigtech/ui-shared-notes-web'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/notes_/form')({
  component: ClaimNoteFormPage,
})

function ClaimNoteFormPage() {
  const { claimNumber } = Route.useParams()

  const claimCorn = ensureClaimCorn(claimNumber)

  const { data: claim } = useGetClaim(claimNumber)
  const includePublishField = useCanPublishClaimInfoToXA({ claim })

  return (
    <Container>
      <CreateEntityNotePage
        entityCorn={claimCorn}
        includePublishField={includePublishField}
        includeTemplateField={false}
        templateParams={claim}
      />
    </Container>
  )
}
